import { StyleSheet } from 'react-native';
import { brand } from 'src/theme/colors';

export const styles = StyleSheet.create({
  previewContainer: {
    width: '100%',
    maxHeight: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  vintageText: {
    opacity: 0.8,
    letterSpacing: 1,
  },
  highlighted: {
    position: 'absolute',
    borderColor: brand.main.water,
    borderWidth: 2,
    borderRadius: 4,
    pointerEvents: "none"
  },
});
